import React from "react";

export default function ManageOrganizationsComponent() {
    return <div>ManageOrganizationsComponent</div>;
}
